import Vue from 'vue'
import SoftSwitch from './index.vue'

const SoftSwitchBox = Vue.extend(SoftSwitch)

SoftSwitch.install = function (options, type) {
  console.log(options, type)
  if (options === undefined || options === null) {
    options = {
      content: ''
    }
  } else if (typeof options === 'string' || typeof options === 'number') {
    options = {
      content: options
    }
  }

  let instance = new SoftSwitchBox({
    data: options
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.visible = true
  })
}

export default SoftSwitch


// WEBPACK FOOTER //
// ./src/components/SoftSwitch/index.js